const logout = () => {
  // Extract language from pathname (e.g., '/az/home-page' -> 'az')
  const lang = window.location.pathname.substring(1, 3);
  // Clear session storage before redirect to ensure it happens
  sessionStorage.clear();
  // Redirect to login page
  window.location.href = `/${lang}/login`;
};

export default logout;
